import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';

import { TRANSLOCO_SCOPE, TranslocoDirective } from '@ngneat/transloco';
import { inlineLoaderFactory } from '@rx-applications/shared/utils';
import { ConfigFacade } from '@rx-applications/clientsite/shared/config/data-access';
import { RoomInformation } from '@rx-applications/clientsite/shared/utils';
import { AsyncPipe, NgIf } from '@angular/common';

@Component({
  selector: 'rx-applications-room-more-details',
  templateUrl: './room-more-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: {
        scope: 'moreDetails',
        loader: inlineLoaderFactory((lang: string) => import(`./../assets/i18n/${lang}.json`)),
      },
    },
  ],
  standalone: true,
  imports: [TranslocoDirective, NgIf, AsyncPipe],
})
export class RoomMoreDetailsComponent {
  configFacade = inject(ConfigFacade);
  @Input() room: RoomInformation;
}
